import { getNumberOfPixels } from '../../../../core/helpers/getNumberOfPixels';
import { isMobile } from '../../../../core/helpers/isMobile';

export const calculateWonUserCoordinatesOnParabola = () => {
  const graphicDiv = document.querySelector('.crash-game-line-chart');
  const graphicDivMaxWidth = getNumberOfPixels(window.getComputedStyle(graphicDiv).maxWidth);
  const graphicDivMaxHeight = getNumberOfPixels(window.getComputedStyle(graphicDiv).maxHeight);

  const x = graphicDiv?.clientWidth;
  const y = (graphicDivMaxHeight / graphicDivMaxWidth ** 2) * x ** 2;

  const mistake = isMobile() ? 10 : 35;

  return {
    x: x - mistake < 0 ? x + mistake : x, // -35 is given for margin from right border
    y,
  };
};
